import '../styles/Aboutus.css';
import { Link, Route, Routes } from 'react-router-dom';
import Joining from './Joining';

const About = () => {
    return (
        <div className='aboutus'>
            <div className="about-main" >
                <div className='about2' id='autoshow-about'>
                    <h1 className="why">About Us </h1>
                    <p className="line"></p>
                    <p id="p1">
                        <b>Precision Quality Innovation:</b><br></br><br></br>
                        At GLOBAL INNOVATION TECHNOLOGIES (GIT), excellence begins with uncompromising quality and operational efficiency. As an ISO 9001:2015 certified company, we are committed to delivering high-precision CNC and VMC machined components that meet the stringent demands of industries such as Aerospace, Defense, Automobile, Hydraulic, and Medical applications.<br></br><br></br>

                        <b>Who We Are:</b><br></br><br></br>
                        Founded in 2020 and based in Bangalore, India, GIT is a small-scale manufacturing company specializing in CNC (Computer Numerical Control) and VMC (Vertical Machining Center) machining. With a strong focus on precision engineering and customer satisfaction, we deliver high-quality, custom-engineered components tailored to our clients' specifications.<br></br><br></br>
                        
                        <div>
                        <b>Our Key Strengths:</b>
                            <div className='key'>

                                ✔ ISO 9001:2015 Certified – Ensuring best-in-class quality management systems<br></br>
                                ✔ Advanced CNC & VMC Machining – Delivering precision components with tight tolerances<br></br>
                                ✔ Industry Expertise – Serving Aerospace, Defense, Automotive, Hydraulic & Medical sectors<br></br>
                                ✔ Customer-Centric Approach – Focused on delivering tailored solutions with on-time delivery<br></br>
                                ✔ End-to-End Quality Assurance – From material selection to final inspection

                                <div className='about1' id='autoshow-img'>
                                </div>
                            </div>
                        </div>


                    </p>
                    <Link to='/join'> <button className='but-free'>Contact Us</button></Link>
                </div>
            </div>
            <div>
                <Routes>
                    <Route path='/join' element={<Joining />} />
                </Routes>
            </div>
        </div>
    );
}

export default About;
